"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _underscore = require("underscore");

var _CustomWidgetTags = _interopRequireDefault(require("ContentUtils/constants/CustomWidgetTags"));

var _CustomWidgetTagGroups = _interopRequireDefault(require("ContentUtils/constants/CustomWidgetTagGroups"));

var TAG_KEYS_MAP = _CustomWidgetTagGroups.default.FUNCTIONS.reduce(function (hash, tag) {
  var tagKey = (0, _underscore.findKey)(_CustomWidgetTags.default, function (_tag) {
    return _tag === tag;
  });
  return (0, _extends3.default)({}, hash, (0, _defineProperty2.default)({}, tagKey, null));
}, {});

var _default = (0, _keyMirror.default)((0, _extends3.default)({}, TAG_KEYS_MAP, {
  NONE: null
}));

exports.default = _default;
module.exports = exports.default;